<template>
<div>
  <h3>{{ $t('payload example') }}</h3>
  <div class="lighter">Make sure, the unique_sensor_name matches the name which is set in the vhub sensor configuration below
  and that the feed is running when testing it. You can send data for multiple sensors in the same request. You won't get a
  negative response if the sensor name doesn't match.</div>
  <pre class="payload-example">
POST {{ feedEndpoint }}

{
  "values": [{
      "unique_sensor_name": "{{ sensorName }}",
      "signal": "{{ sensorName }}",
      "value": "some-value",
      "timestamp": "2024-04-25T11:09:43.1827807+03:00"
    }]
}
  </pre>
  <div @click="$router.push('/library/datasource/' + feedId + '/general')"
       class="settings-button switched-colors d-inline-block">
    {{ $t('go to feed')}}
  </div>
</div>
</template>

<script>
import {SpecialUuids} from "../enum";
import {getValueForMetaFieldFromMetaSets} from "../utils";
export default {
  name: "SensorEdit",
  props: {
    sensorId: {type: String, required: true},
    metaSets: {required: true},
    sensorName: {type: String, required: true}
  },
  data() {
    return {
      feedId: null,
      feedHost: ''
    };
  },
  computed: {
    feedEndpoint() {
      if(this.feedId && this.feedHost) {
        return this.feedHost + `feeds/${this.feedId}/event`
      }
      return 'loading host...'
    }
  },
  watch: {
    metaSets() {
      this.getSourceFeedFromMetaFields();
    }
  },
  beforeMount() {
    this.loadFeedUrl();
    this.getSourceFeedFromMetaFields();
  },
  methods: {
    loadFeedUrl() {
      return fetch(process.env.VUE_APP_CONFIG)
          .then(r => r.json())
          .then(config => {
            const {feedHost, feedPath} = config.sfx.project.webapp;
            this.feedHost = feedHost + feedPath + '/api/v2/'
          })
    },
    getSourceFeedFromMetaFields() {
      if(this.metaSets && this.metaSets.length) {
        this.feedId = getValueForMetaFieldFromMetaSets(this.metaSets, SpecialUuids.SENSOR_SOURCE_FEED_METAFIELD);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.payload-example {
  color: #fff;
}
</style>